define('viewmodels/survey/ResponsibilityGroup',['knockout', 'plugins/router', 'services/appsecurity', 'services/navigation', 'durandal/app', 'durandal/system', 'services/logger'], function (ko, router, appsecurity, navigation, app, system, logger) {

    var YrViewModel = {
        activate: activate,
        attached: attached,
        appsecurity: appsecurity,
        CreateNewGroup: CreateNewGroup,
        popUpTitle: ko.observable(),
        GroupName: ko.observable(),
        GroupDesc: ko.observable(),
        EditGroupName: ko.observable(),
        EditGroupDesc: ko.observable(),
        DeleteGroupId: ko.observable(),
        addPopUpCss: ko.observable(),
        UserMappingList: ko.observableArray([]),
        Copyconfigurations: ko.observable(),
        UserGroupList: ko.observableArray(),
        editGroupID: ko.observable(),
        YearofAssessmentList: ko.observableArray(),
        ValidYearDetails: ko.observableArray(),
        YearDetails: ko.observableArray(),
        PopUpOpenId: ko.observable(),
        AllYearDetails: ko.observableArray([]),
        CurrentYearofAssessment: ko.observable(),
        SaveNewGroup: SaveNewGroup,
        saveEditResponsibilityGroupPopup: saveEditResponsibilityGroupPopup,
        OpenUserDetailsPopup: OpenUserDetailsPopup,
        SelectAllUsers: SelectAllUsers,
        SaveResponsibilityGroupMapping: SaveResponsibilityGroupMapping,
        editGroupDetails: editGroupDetails,
        ControlsAccess: ko.observable(true),
        Savedisabled: ko.observable(true),
        writeAccess: ko.observable(),
        showDeleteGroupPopup: showDeleteGroupPopup,
        confirmDeleteGroup: confirmDeleteGroup,
        setupDeatilsArray: ko.observableArray([]),
        SelectedSetupType: ko.observableArray([]),
        IsSharedResponsibilityGroup: ko.observable(false),
        setupDeatilsArrayModified: ko.observableArray([]),
        ZATList: ko.observableArray([]),
        ZATListModified: ko.observableArray([]),
        SelectedZATList: ko.observableArray([]),
        ControlsAccess: ko.observable(false),
        SelectedZATModel: ko.observableArray([]),
        ApplicabilityChanged: ApplicabilityChanged,
        ZATSelected: ko.observable(false),

    };
    return YrViewModel;

    function activate() {
        try {
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: activate() method in ResponsibilityGroup.js';
            logger.logMessage(msg);
        }
    }

    function attached() {
        try {
            if (appsecurity.isConfigurationFreeze() === undefined) {
                appsecurity.GetConfigurationFreezeFlag().then(function () {
                    if (appsecurity.WriteAccess() == true && !appsecurity.isConfigurationFreeze()) {
                        YrViewModel.ControlsAccess(true);
                    }
                    else {
                        YrViewModel.ControlsAccess(false);
                    }
                });
            }
            else if (appsecurity.WriteAccess() == true && !appsecurity.isConfigurationFreeze()) {
                YrViewModel.ControlsAccess(true);
            }
            else {
                YrViewModel.ControlsAccess(false);
            }
            GetZATList();
            getUserGroupData();
            getResponsibilityGroupSetUpTypeData().then(function () {
                $('#ComponentApplicability').multiselect();
                $('#ComponentApplicability').multiselect('refresh');
            });

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: attached() method in ResponsibilityGroup.js';
            logger.logMessage(msg);
        }
    }

    function GetZATList() {
        try {
            return $.ajax({
                url: "/api/Configuration/GetAllSurveyCategories",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetZATList() method in ResponsibilityGroup.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null) {
                    if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null) {
                        logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(YrViewModel), true);
                    }
                    else {
                        var mappedList = $.map(jsonResult, function (result) {
                            return new SurveyCategoryModel(result);

                        });
                        YrViewModel.ZATList(mappedList);
                    }
                }
                else
                    logger.logError('An error has occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(YrViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetZATList() in ResponsibilityGroup.js';
                logger.logMessage(msg);

            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetZATList() method in ResponsibilityGroup.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetZATList() method in ResponsibilityGroup.js';
                logger.logMessage(msg);
            }
        }
    }

    //-------------------------------------------------Function that opens the create group popup starts here----------------------------------------------------------------
    function CreateNewGroup(data, event) {
        try {
            YrViewModel.popUpTitle("Create New Group");
            YrViewModel.addPopUpCss(true);
            YrViewModel.GroupName('');
            YrViewModel.GroupDesc('');
            YrViewModel.IsSharedResponsibilityGroup(false);
            $('#CreateNewGroupPopup').modal('show');
            $('#valcreateerror').hide();
            $('#valcreateerror').text('');
            YrViewModel.SelectedZATList([]);
            YrViewModel.SelectedZATModel([]);
            $('#ZATApplicability').multiselect();
            $('#ZATApplicability').multiselect('refresh');

        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in CreateNewGroupPopup() method in ResponsibilityGroup.js';
            logger.logMessage(msg);
        }
    }

    function showDeleteGroupPopup(data, event) {
        try {
            YrViewModel.DeleteGroupId(data.Id());
            YrViewModel.popUpTitle("Confirm Delete");
            YrViewModel.addPopUpCss(true);
            $('#deleteGroupDetails').modal('show');
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in showDeleteGroupPopup() method in ResponsibilityGroup.js';
            logger.logMessage(msg);
        }
    }

    function confirmDeleteGroup(data, event) {
        try {
            $('#deleteGroupDetails').modal('hide');
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Calculation/DeleteResponsibilityGroup",
                headers: headers,
                type: "POST",
                data: { _Id: parseInt(data.DeleteGroupId()) }
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call from CreateNewUserGroup() method in ResponsibilityGroup.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (parseInt(jsonResult) > 0) {
                    logger.logSuccess('Responsibility Group has been deleted successfully.', 'Success', system.getModuleId(YrViewModel), true);
                    getUserGroupData();
                }
                else {
                    logger.logError(jsonResult + " - " + 'An error occurred while deleting group. Please contact your Administrator.', 'Error', system.getModuleId(YrViewModel), true);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess from confirmDeleteGroup() method in ResponsibilityGroup.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();

                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in CreateNewUserGroup() method in ResponsibilityGroup.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail from confirmDeleteGroup() method in ResponsibilityGroup.js';
                logger.logMessage(msg);
            }
        }
    }
    function editGroupDetails(data, event) {
        try {
            YrViewModel.editGroupID(data.Id());
            YrViewModel.EditGroupName(data.GroupName());
            YrViewModel.EditGroupDesc(data.GroupDesc());
            $('#MappedSurveyComponents').val(data.SetupDetails());
            $('#SharedRGState').val(data.IsSharedResponsibilityGroup() == 1 ? 'Yes' : 'No');
            if (data.IsSharedResponsibilityGroup() == 1)
                $('#CombinedZATEdit').show();
            else
                $('#CombinedZATEdit').hide();
            $('#MappedCombinedSurveyComponents').val(data.CombinedSetupDetails());
            $('#editGroupDetails').modal("show")
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: editGroupDetails() method in ResponsibilityGroup.js';
            logger.logMessage(msg);
        }

    }


    function getResponsibilityGroupSetUpTypeData() {
        try {
            $.ajax({
                url: "/api/Calculation/getResponsibilityGroupSetUpTypeDetails",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);

            function ajaxSuccess(jsonResult, status) {
                if (jsonResult != null) {
                    if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null) {
                        logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(YrViewModel), true);
                    }
                    else {
                        YrViewModel.setupDeatilsArray([])
                        var MappedSetupDetails = $.map(jsonResult, function (result) {
                            return new SetupDetailsModel(result);
                        });
                        YrViewModel.setupDeatilsArray(MappedSetupDetails)
                    }
                } else {
                    logger.logError('An error occurred. Please contact your Administrator.', 'Error', system.getModuleId(YrViewModel), true);
                }

            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();

                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in getResponsibilityGroupSetUpTypeData() method in ResponsibilityGroup.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail from getResponsibilityGroupSetUpTypeData() method in ResponsibilityGroup.js';
                    logger.logMessage(msg);
                }
            }
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: getResponsibilityGroupSetUpTypeData() method in ResponsibilityGroup.js';
            logger.logMessage(msg);
        }
    }


    function SetupDetailsModel(item) {
        try {
            var self = this;
            self.setUpId = ko.observable(item.Id);
            self.setUpName = ko.observable($('<div/>').html(item.SetUp_Details).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: UserProfileMappingModel() method in ResponsibilityGroup.js';
            logger.logMessage(msg);
        }

    }

    function getUserGroupData() {
        try {
            $.ajax({
                url: "/api/Calculation/GetResponsibilityGroupDetails",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: getUserGroupData() method in ResponsibilityGroup.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null && jsonResult != null) {
                    logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(YrViewModel), true);
                }
                else if (jsonResult.length == 0)
                    logger.logError('No records present.', 'Warning', system.getModuleId(YrViewModel), true);
                var MappedGroupDetails = $.map(jsonResult, function (result) {
                    return new UserGroupModel(result);
                });

                tableObj = $('#tblReportDetails').DataTable();
                tableObj.destroy();
                $('#tblReportDetails tbody tr').remove();
                QuestionTableObj = undefined;
                YrViewModel.UserGroupList([]);
                YrViewModel.UserGroupList(MappedGroupDetails)
                QuestionTableObj = $('#tblReportDetails').DataTable({
                    "order": [],
                    "aaSorting": [],
                    "bResponsive": true,
                    "aoColumnDefs": [
                        {
                            "aTargets": [1],
                            "bVisible": true,
                            "bSortable": false

                        }, {
                            "aTargets": [2],
                            "bVisible": true,
                            "bSortable": true

                        }, {
                            "aTargets": [3],
                            "bVisible": true,
                            "bSortable": false

                        },
                        {
                            "aTargets": [4],
                            "bVisible": true,
                            "bSortable": false

                        }
                    ]
                });

                $('#tblReportDetails').DataTable().draw(false);

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess from getUserGroupData() method in ResponsibilityGroup.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();

                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in getUserGroupData() method in ResponsibilityGroup.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail from getUserGroupData() method in ResponsibilityGroup.js';
                logger.logMessage(msg);
            }
        }

    }

    //-----------------------------------------------------------------Function that is invoked on click of save for the create new group starts here---------------------------------
    function SaveNewGroup(data, event) {
        try {
            $('#valcreateerror').hide();
            data.GroupName();
            data.GroupDesc();
            data.IsSharedResponsibilityGroup();
            var selectedSetupTypeId = data.SelectedZATList().join('|');
            if (data.GroupName() == null || data.GroupName == 'undefined' || data.GroupName() == '' || selectedSetupTypeId.trim() == '' || selectedSetupTypeId == null) {
                $('#valcreateerror').text('Please enter all the required fields');
                $('#valcreateerror').show()
                return;
            }
            var IsSharedResponsibilityGroupVar = "";
            if (data.IsSharedResponsibilityGroup())
                IsSharedResponsibilityGroupVar = 1;
            else
                IsSharedResponsibilityGroupVar = 0;

            var selectedSetupCombinedFlagList = [];
            for (var i = 0; i < data.SelectedZATList().length; i++) {
                if ($('#ZATSurveyIsCombined_' + data.SelectedZATList()[i]).is(":checked")) {
                    selectedSetupCombinedFlagList.push(data.SelectedZATList()[i]);
                }
            }
            var selectedSetupCombinedFlagAllId = selectedSetupCombinedFlagList.join('|');
            CreateNewUserGroup(data.GroupName(), data.GroupDesc(), selectedSetupTypeId, selectedSetupCombinedFlagAllId, IsSharedResponsibilityGroupVar);
            $('#CreateNewGroupPopup').modal('hide');
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SaveNewGroup() method in ResponsibilityGroup.js';
            logger.logMessage(msg);
        }
    }

    function ApplicabilityChanged(data,event) {
        var selectedZAT = data.SelectedZATList();
        if (selectedZAT.length > 0) {
            YrViewModel.ZATSelected(true);
        } else {
            YrViewModel.ZATSelected(false);
        }
        YrViewModel.SelectedZATModel([]);
        for (var i = 0; i < selectedZAT.length; i++) {
            for (var j = 0; j < YrViewModel.ZATList().length; j++) {
                if (selectedZAT[i] == YrViewModel.ZATList()[j].SurveyCategoryId()) {
                    YrViewModel.SelectedZATModel.push(new ZATModel({
                        SurveyCategoryId: YrViewModel.ZATList()[j].SurveyCategoryId(),
                        SurveyCategoryName: YrViewModel.ZATList()[j].SurveyCategoryName(),
                        IsCombinedFlag: false
                    })
                    );
                }
            }
        }

    }
    //-----------------------------------------------------------------Function that is invoked on click of save for the create new group ends here--------------------------------


    function saveEditResponsibilityGroupPopup(data, event) {
        try {
            var duplicate = 0;
            var Id = data.editGroupID();
            var group_name = data.EditGroupName();
            var group_desc = data.EditGroupDesc();
            if (group_name == null || group_name == 'undefined' || group_name == '') {
                $('#valErrorYSEdit').text('Please enter all the required fields.');
                $('#valErrorYSEdit').show();
                return;
            }
            SaveEditGroupDetails(Id, group_name, group_desc);

            $('#valErrorYS').hide();
            $('#editGroupDetails').modal('hide');
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: saveEditResponsibilityGroupPopup() method in ResponsibilityGroup.js';
            logger.logMessage(msg);
        }
    }



    //---------------------------------------------------------------Function that is invoked on click of save of the change assessmentprofile ends here---------------------------------------


    function CreateNewUserGroup(GroupName, GroupDesc, setupTypeId, CombinedFlagId,IsSharedResponsibilityGroup) {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Calculation/CreateNewResponsibilityGroup",
                headers: headers,
                type: "POST",
                data: { _Group_name: GroupName, _Group_desc: GroupDesc, _SetupString: setupTypeId, _SetupCombinedFlagString: CombinedFlagId, _IsSharedRG: IsSharedResponsibilityGroup  }
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call from CreateNewUserGroup() method in ResponsibilityGroup.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                var code = jsonResult.slice(0, 2);
                var msg = jsonResult.slice(3, 12);
                if (jsonResult == '1') {
                    logger.logSuccess('Responsibility Group has been created successfully.', 'Success', system.getModuleId(YrViewModel), true);
                    getUserGroupData();
                }
                else if (code == '-1') {
                    logger.logWarning(msg + " - " + 'Responsibility Group name already exists.', 'Warning', system.getModuleId(YrViewModel), true);

                    $('#valfactorerror').text('Responsibility Group Name Already Exists.');
                    $('#valfactorerror').show();
                } else
                    logger.logError(jsonResult + " - " + 'An error occurred while creating group. Please contact your Administrator.', 'Error', system.getModuleId(YrViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess from CreateNewUserGroup() method in ResponsibilityGroup.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();

                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in CreateNewUserGroup() method in ResponsibilityGroup.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail from CreateNewUserGroup() method in ResponsibilityGroup.js';
                logger.logMessage(msg);
            }
        }
    }
    //------------------------------Function that creates new profile of assessment without copying configurations ends here-----------------



    function SaveEditGroupDetails(id, group_name, group_desc, selectedEditSetupTypeId) {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Calculation/SaveEditResponsibilityGroupDetails",
                type: "POST",
                headers: headers,
                data: { _Group_name: group_name, _Group_desc: group_desc, _Id: id}
            })
                .success(function (jsonResult, error) {
                    if (jsonResult == '1') {
                        logger.logSuccess('Group Details Have Been Edited Successfully.', 'Success', system.getModuleId(YrViewModel), true);
                        getUserGroupData();
                    }
                    else
                        logger.logError(jsonResult + " - " + 'An error occurred while editing group details. Please contact your Administrator.', 'Error', system.getModuleId(YrViewModel), true);

                })
                .fail(function (error, status) {
                    logger.logError('An error has occurred while editing group details. Please contact the Application Administrator.', 'Error', system.getModuleId(YrViewModel), true);
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in SaveEditGroupDetails() method in ResponsibilityGroup.js';
            logger.logMessage(msg);
        }
    }

    //------------------------------Function that gets the userdetails starts here--------------------------------------------------------------------------------
    function GetUserProfileMappings() {
        try {
            return $.ajax({
                url: "/api/Calculation/GetAllResponsibilityGroupMapping",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: { Id: parseInt(YrViewModel.PopUpOpenId()) }
            })
                .success(function (jsonResult, error) {
                    if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null && jsonResult != null) {
                        logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(YrViewModel), true);
                    }
                    else {
                        YrViewModel.UserMappingList([]);
                        tableObj = $('#UserProfileMappingTable').DataTable();

                        tableObj.destroy();
                        $('#UserProfileMappingTable tbody tr').remove();

                        var MappeduserProfileList = $.map(jsonResult, function (result) {
                            return new UserProfileMappingModel(result);
                        });
                        YrViewModel.UserMappingList(MappeduserProfileList);
                        $('#UserProfileMappingTable').dataTable();
                    }
                 })
        
                .fail(function (error, status) {
                    logger.logError('An error has occurred while fetching the User Details.', 'Error', system.getModuleId(YrViewModel), true);
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetUserProfileMappings() method in ResponsibilityGroup.js';
            logger.logMessage(msg);
        }
    }
    //------------------------------Function that gets UserDetails ends here--------------------------------------------------------------------------------------
    //------------------------------Function That gets called on click of the manageuseractions action button starts here-------------------------------------------------------------------
    function OpenUserDetailsPopup(data, event) {
        try {
            YrViewModel.PopUpOpenId(parseInt(data.Id()));

            GetUserProfileMappings().then(function () {
                YrViewModel.popUpTitle("Mapped Users");
                YrViewModel.addPopUpCss(true);
                $('#UserProfileMapping').modal('show');
            })


        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in OpenUserDetailsPopup() method in ResponsibilityGroup.js';
            logger.logMessage(msg);
        }
    }
    //------------------------------Function that gets called on click of the manageuseractions action button ends here---------------------------------------------------------------------

    //------------------------------Logic to Fetch User Details and List of All Roles Starts Here----------------------------------------------

    //------------------------------Function to save the user profile mapping starts here----------------------
    function SaveResponsibilityGroupMapping(data, event) {
        try {

            var userList = JSON.stringify($.map(data.UserMappingList(), function (result) {
                if (result.IsMapped() == true) {
                    return { _User_Id: result.UserId(), _Id: YrViewModel.PopUpOpenId() };
                }
            }));
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            return $.ajax({
                url: "/api/Calculation/SaveResponsibilityGroupMappings?GroupId="+YrViewModel.PopUpOpenId(),
                type: "POST",
                headers: headers,
                contentType: 'application/json',
                dataType: 'json',
                data: userList
            })
                .success(function (jsonResult, error) {
                    YrViewModel.UserMappingList([]);
                    var MappeduserProfileList = $.map(jsonResult, function (result) {
                        return new UserProfileMappingModel(result);
                    });
                    YrViewModel.UserMappingList(MappeduserProfileList);
                    $('#UserProfileMapping').modal('hide');
                    logger.logSuccess('Users has been assigned successfully to the Group.', 'Success', system.getModuleId(YrViewModel), true);

                })
                .fail(function (error, status) {
                    logger.logError('An error has occurred while saving the User Details.', 'Error', system.getModuleId(YrViewModel), true);
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in SaveResponsibilityGroupMappings() method in ResponsibilityGroup.js';
            logger.logMessage(msg);
        }
    }
    //-----------------------------------------------------------------------Function to save the user profile mapping ends here-------------------------


    //-----------------------------------------------------------------------Function Thats gets called on hit of SelectAllUsers checkbox starts here-------------------------
    function SelectAllUsers(data, event) {
        try {

            if (event.currentTarget.checked) {
                for (var i = 0; i < YrViewModel.UserMappingList().length; i++) {
                    YrViewModel.UserMappingList()[i].IsMapped(true);
                }

            }
            else {
                for (var i = 0; i < YrViewModel.UserMappingList().length; i++) {
                    YrViewModel.UserMappingList()[i].IsMapped(false);
                }
            }
            var rows = $("#UserProfileMappingTable").dataTable().fnGetNodes();
            var cells = [];
            for (var i = 0; i < rows.length; i++) {
                if (event.currentTarget.checked == true)
                    $(rows[i]).find("td:eq(0)").find('input').prop("checked", true);
                else
                    $(rows[i]).find("td:eq(0)").find('input').prop("checked", false);
            }

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in SelectAllUsers() method in ResponsibilityGroup.js';
            logger.logMessage(msg);
        }
    }

    //Model to Store the Profileofassessmentdetails
    function UserGroupModel(item) {
        try {
            var self = this;
            self.ConfigurationFreezeFlag = ko.observable('true');
            self.Id = ko.observable($('<div/>').html(item._Id).text());
            self.GroupName = ko.observable($('<div/>').html(item._Group_name).text());
            self.GroupDesc = ko.observable($('<div/>').html(item._Group_desc).text());
            self.SetupIds = ko.observable(item._SetupIds);
            self.SetupDetails = ko.observable($('<div/>').html(item._SetupString).text());
            self.IsSharedResponsibilityGroup = ko.observable(item._IsSharedRG);
            self.CombinedSetupDetails = ko.observable($('<div/>').html(item._SetupCombinedFlagString).text());
            self.DeleteFlag = ko.observable(item.DeleteFlag);
            var MappedList = null;
            if (item.SurveyComponentsModelList && item.SurveyComponentsModelList.length > 0) {
                MappedList = $.map(item.SurveyComponentsModelList, function (result) {
                    return new SurveyComponentsModel(result);
                });
            }
            self.SurveyComponentsModel = ko.observableArray(MappedList);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: UserGroupModel() method in CalculationStatus.js';
            logger.logMessage(msg);
        }
    }
    function SurveyComponentsModel(item) {
        try {
            var self = this;
            self.SurveyCompId = ko.observable(item.Id);
            self.SurveyCompName = ko.observable(item.SetUp_Details);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SurveyComponentsModel() method in CalculationStatus.js';
            logger.logMessage(msg);
        }
    }
    //Model to store the mapping between user and profile
    function UserProfileMappingModel(item) {
        try {
            var self = this;
            self.UserId = ko.observable(item.UserId);
            self.UserName = ko.observable($('<div/>').html(item.UserName).text());
            self.PrimaryRoleName = ko.observable($('<div/>').html(item.PrimaryRoleName).text());
            self.IsMapped = ko.observable(item.IsActive);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: UserProfileMappingModel() method in ResponsibilityGroup.js';
            logger.logMessage(msg);
        }
    }

    function SurveyCategoryModel(item) {
        try {
            var self = this;
            self.SurveyCategoryId = ko.observable(item.SurveyCategoryId);
            self.SurveyCategoryName = ko.observable(item.SurveyCategoryName);
            self.SurveyGroupShortName = ko.observable(item.SurveyGroupShortName);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SurveyCategoryModel() method in ResponsibilityGroup.js';
            logger.logMessage(msg);
        }
    }

    function ZATModel(item) {
        var self = this;
        self.SurveyCategoryId = ko.observable(item.SurveyCategoryId);
        self.SurveyCategoryName = ko.observable(item.SurveyCategoryName);
        self.IsCombinedFlag = ko.observable(item.IsCombinedFlag);
    }

    //------------------------------------------------------------------------Model Definition Ends Here-----------------------------------------------------------------------------

});
